// extracted by mini-css-extract-plugin
export default {"root":"ChartLegend_root__vL7mI","item":"ChartLegend_item__lw1s1","square":"ChartLegend_square__rl1c-","label":"ChartLegend_label__57ATA"};